import { render } from "./CaseAddCustomer.vue?vue&type=template&id=0a9cd1cc&scoped=true"
import script from "./CaseAddCustomer.vue?vue&type=script&lang=js"
export * from "./CaseAddCustomer.vue?vue&type=script&lang=js"

import "./CaseAddCustomer.vue?vue&type=style&index=0&id=0a9cd1cc&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9cd1cc"]])

export default __exports__